<template>
	<div id="app">
		<div id="nav" class="f-cb">
			<!--我是头部-->
			<div class="f-fl">
				<img src="./assets/imgs/logo.png" class=" logo " />
			</div>
			<div class="f-fl">
				<!--<img src="./assets/imgs/logo.png"  class=" logo"/>-->
				<!--<span style="font-size: 20px;letter-spacing: 2px;margin-top: 10px;">码标注册解析公共服务平台
			<p>UTC旗下品牌</p>
			</span>-->
			</div>
			<div class="f-fr">

				<div class="use-box">
					<!--<i class="iconfont">&#xe63b;</i>-->
					<span><i class="iconfont"> &#xe63b;</i>  当前用户：</span>
					<span style="padding-right: 10px;">{{$store.state.commonalityData.name}}</span>|
					<a :href="quitUrl" style="padding-left: 10px;">返回首页</a>
				</div>
				<!--<div class="operating">
					<a href="#"></a>
					<router-link to="/Safety">修改密码</router-link> <i style="color: #7996bc;padding: 0 20px;">|</i> <span class="quit" @click="quit">退出</span>
				</div>-->
				<div class="control-box">
					<!--@click="downloadFn"-->
					<a  href="/UploadFiles/码标注册解析公共服务平台（用户操作手册V2.7）.pdf" style="margin-right: 10px;"><el-button type="primary" plain size="mini" >操作手册 </el-button></a> 
					<el-button type="primary" plain size="mini" @click="$router.push('/Safety')">修改密码 </el-button>
					<el-button type="primary" plain size="mini" @click="quit">退出</el-button>
				</div>
			</div>
		</div>
		<!--default-active="/genre"-->
		<div class="g-bd1 f-cb">
			<div class="g-sd1" style="background-color:#f9f9f9 !important;">
				<el-menu background-color="#fff" style="min-height: 800px;padding-top: 10px;" class="el-menu-vertical-demo" :default-openeds='["1","2","3"]' :default-active="routerBaseBegin" @select="transfer">
					<el-submenu index="1">
						<template slot="title">
							<div class="columntrait">
								<img src="./assets/imgs/11111.png" />
								<span>我的资料</span>
							</div>
						</template>
						<el-menu-item-group style="margin-top: -20px;">
							<el-menu-item index="/" :route='{ path: "/" }'>基本信息</el-menu-item>
							<el-menu-item index="/Safety" :route='{ path: "/Safety" }'>密码设置</el-menu-item>
						</el-menu-item-group>

					</el-submenu>
					<el-submenu index="2">
						<template slot="title">
							<div class="columntrait">
								<img src="./assets/imgs/iocn1.png" />
								<span>码标管理</span>
							</div>
						</template>
						<el-menu-item-group style="margin-top: -20px;">
							<!-- <el-menu-item index="/productregister" :route='{ path: "/productregister" }'>企业码标注册</el-menu-item> -->
							<el-menu-item index="/enterprisemb" :route='{ path: "/enterprisemb" }'>企业码标管理</el-menu-item>
							<!-- <el-menu-item index="/genre" :route='{ path: "/genre" }'>品类码标注册</el-menu-item> -->
							<!-- <el-menu-item index="/genrelist" :route='{ path: "/genrelist" }'>品类码标解析</el-menu-item> -->
						</el-menu-item-group>
					</el-submenu>
					<!--<el-submenu index="3">
						<template slot="title">
							<div class="columntrait">
								<img src="./assets/imgs/iocn1.png" />
								<span>轻应用</span>
							</div>
						</template>
					</el-submenu>-->
					<el-submenu index="3">
						<template slot="title">
							<div class="columntrait">
								<img src="./assets/imgs/iocn1.png" />
								<span>轻应用</span>
							</div>
						</template>
						<el-menu-item-group style="margin-top: -20px;">
							<el-menu-item v-show="$store.state.commonalityData.platformRole == 5" index="/personalCard" :route='{ path: "/personalCard" }'>个人名片</el-menu-item>
							<el-menu-item v-show="$store.state.commonalityData.platformRole == 4" index="/companyCard" :route='{ path: "/companyCard" }'>企业名片</el-menu-item>
						    <el-menu-item v-show="$store.state.commonalityData.platformRole == 4" index="/GoodsCode" :route='{ path: "/GoodsCode" }'>商品名片</el-menu-item>
						</el-menu-item-group>
					</el-submenu>
					<el-menu-item index="/mtStyle" :route='{ path: "/mtStyle" }'>
						<i class="el-icon-menu"></i>
						<span slot="title">码图样式设置</span>
					</el-menu-item>
				</el-menu>

			</div>
			<!--<a href="https://www.baidu.com/baidu?wd=%E7%99%BE%E5%BA%A6&tn=monline_4_dg&ie=utf-8" target="_blank" id="guidance"></a>-->
			<div class="g-mn1">
				<!--{{$store.state.resistshow}}-->
				<!--$store.state.resistshow-->
				<div class="tentative-box" v-show="$store.state.resistshow">
					<div class="j-describe" v-if="!$store.state.commonalityData.IdcodeUserId">
						<span class="con">很抱歉！您还没有完善资料，不能{{  $route.path == '/genreslip' ?'注册品类码标':'使用轻应用'}}，现在去</span>
						<el-button type="primary" round size="mini" @click="$router.push({ path:'perfect'})">完善资料 </el-button>
					</div>
					<div class="j-describe" v-else-if="$store.state.resistCode == 503 && $route.path == '/genreslip'">
						
						<span class="con"> 很抱歉！您还没有注册任何企业码标，不能{{  $route.path == '/genreslip' ?'注册品类码标':'使用轻应用'}}，现在去</span>
						<el-button type="primary" round size="mini" @click="$router.push({ path:'productregister'})">注册企业码标</el-button> 
					</div>
					<!--$store.state.commonalityData.platformRole === 5-->
					<!-- <div class="j-describe" v-else-if="$store.state.commonalityData.platformRole == 5">
						<span class="con">个人用户暂不支持此功能</span>
					</div> -->
					<!--<div class="j-describe" v-show="$store.state.resistCode == 5">
						<span class="con">个人用户暂不支持此功能！</span>
					</div>-->

					<!--<div class="j-describe" v-for="(item,index) in resistDatas" v-show="$store.state.resistCode == item.type">
						<span class="con"> {{item.con}}</span>
						<el-button type="primary" @click="$router.push({ path: item.router})" round size="mini" v-if="item.router">{{item.routerTlt}}</el-button>
						<span style="font-size: 16px;vertical-align: middle;color: #1B59A8;">！</span>
					</div>-->

				</div>
				<div class="g-mn1c">
					<div style="">
						<!--v-show="breadcrumbData[0].name != '首页'"-->
						<!--<el-breadcrumb separator-class="el-icon-arrow-right">-->
							<!--<el-breadcrumb-item v-for='(item,index) in $store.state.' :to='{path:item.url}'   :key="index">{{item.name}}</el-breadcrumb-item>-->
							<!--<el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
						<el-breadcrumb-item>活动管理</el-breadcrumb-item>
						<el-breadcrumb-item>活动列表</el-breadcrumb-item>
						<el-breadcrumb-item>活动详情</el-breadcrumb-item>-->
						<!--</el-breadcrumb>-->
					</div>
					<!--<p>右侧自适应</p>-->
					<router-view/>
				</div>
			</div>
		</div>

	</div>
</template>
<script>
	export default {
		data() {
			return {
				isPersonal: true,
				crumbs: '',
				breadcrumbData: [],
				routerBaseBegin: '/',
				resistDatas: [{
						con: ' 很抱歉！您还没有注册任何企业码标，不能注册品类码标，现在去',
						router: 'productregister',
						routerTlt: '注册企业码标',
						type: '503'
					},
					{
						con: ' 个人用户暂不支持此功能',
						router: false,
						//						routerTlt: '注册企业码标',
						type: '5'
					}
				]

			}
		},
		created() {
			this.navlighthouse();
			this.bodyguard();
			// console.log(this.$store.state.commonalityData.platformRole)	//4 企业，5 个人
		},
		computed: {
			
			quitUrl(){
			return 	this.$route.query.hasOwnProperty('user')?'../index.html?user='+this.$route.query.user:'../index.html';
				
			}
			
		},
		methods: {
			downloadFn(){
				window.open('/UploadFiles/码标注册解析公共服务平台（用户操作手册V1.6).pdf')
			},
			quit() {
				this.$http.get(this.$api + '/unitLogin/unitExit', ).then(res => {
					if(res.body.result === 1) {
						this.$delCookie('Data');
						window.location.href =this.quitUrl
//						'../index.html'

					}
				})
			},
			transfer(index) {
				this.$router.push({
					path: index
				})
			},
			bodyguard() {
				this.$http.post(this.$api + '/websiteManage/domanIntercept', {
					domain: window.location.protocol + "//" + window.location.host
				}).then(res => {
					// if(res.body.result != 1) {
					// 	window.location.href = '../404.html'
					// }
				})

				let cookieDatas = this.$getCookie('Data') != '' ? JSON.parse(unescape(this.$getCookie('Data'))) : '';
				if(cookieDatas != '') {
					this.$store.dispatch('DataUpdate', cookieDatas)
				} else {
					this.$alert('尚未登录,请点击确定前往官网登录', '提示', {
						confirmButtonText: '确定',
						callback: () => {
							window.location.href = "../index.html";

						}
					});

				}

			},
			navlighthouse() {
				this.routerBaseBegin = this.$route.meta.subordinate ? this.$route.meta.subordinate : this.$route.path;
			},
			// LightApplications() {
			// 					console.log(this.$store.state.commonalityData)
			// 	if(this.$store.state.commonalityData.platformRole === 5) {
			// 		//					console.log()
			// 		//					this.$alert('该功能仅支持单位用户', '提示', {});
			// 		this.$store.commit('resist', 5)
			// 		this.$router.push({
			// 			path: 'lightapp'
			// 		})

			// 	} else if(!this.$store.state.commonalityData.IdcodeUserId) {
			// 		//					this.$alert('请先完善资料', '提示', {
			// 		//						callback: action => {
			// 		//							this.$router.path('/perfect')
			// 		//						}
			// 		//
			// 		//					})
			// 		this.$store.commit('resist');
			// 		this.$router.push({
			// 			path: 'lightapp'
			// 		});

			// 	} else {
			// 		let newPage = window.open("", '_blank');
			// 		this.$http.post(this.$api + '/lightApplication/idcodeLogin').then(res => {

			// 			if(res.body.result === 1) {

			// 				newPage.location = res.body.entity.url;

			// 			}

			// 		})

			// 	}

			// }
			showStyleset() {
				this.$router.push({
					path: ''
				});
			}

		},
		watch: {
			$route(to, form) {
				this.navlighthouse();
				this.bodyguard();
			}

		}

	}
</script>
<style lang="scss">
	/*import 'assets/css/function.css'*/
	
	@import"assets/css/reset.css";
	@import"assets/css/function.css";
	@import "@/assets/css/whole.scss";
	html,
	body {
		box-sizing: border-box;
		width: 100%;
		height: 100%;
		margin: 0;
		padding: 0;
		font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
	}
	
	@font-face {
		font-family: 'iconfont';
		src: url('//at.alicdn.com/t/font_831065_4jiq44axvf4.eot');
		src: url('//at.alicdn.com/t/font_831065_4jiq44axvf4.eot?#iefix') format('embedded-opentype'), url('//at.alicdn.com/t/font_831065_4jiq44axvf4.woff2') format('woff2'), url('//at.alicdn.com/t/font_831065_4jiq44axvf4.woff') format('woff'), url('//at.alicdn.com/t/font_831065_4jiq44axvf4.ttf') format('truetype'), url('//at.alicdn.com/t/font_831065_4jiq44axvf4.svg#iconfont') format('svg');
	}
	
	.iconfont {
		font-family: "iconfont" !important;
		font-size: 16px;
		font-style: normal;
		-webkit-font-smoothing: antialiased;
		-webkit-text-stroke-width: 0.2px;
		-moz-osx-font-smoothing: grayscale;
	}
	
	.error-me-tlt {
		color: #f56c6c;
		padding: 28px 0;
		font-size: 14px;
	}
	
	#app {
		font-family: 'Avenir', Helvetica, Arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		text-align: center;
		color: #2c3e50;
		min-width: $overall-W;
		box-sizing: border-box;
		width: 100%;
		height: 100%;
	}
	
	#nav {
		background-color: $theme-color;
		width: 100%;
		/*border: solid red 1px;*/
		box-sizing: border-box;
		padding: 18px 22px;
		color: white;
		.operating {
			margin-left: 32px;
			display: inline-block;
			a {
				color: white;
				font-size: 14px;
			}
			.quit {
				color: white;
				cursor: pointer;
				/*border-left: solid #7996bc;*/
				font-size: 14px;
			}
		}
	}
	
	.g-bd1 {
		width: 100%;
		height: calc(100% - 100px);
		/*padding-top: 10px;*/
	}
	
	.g-sd1 {
		position: relative;
		float: left;
		text-align: left;
		width: 210px;
		/*padding-top: 10px;*/
		/*border: solid red 1px;*/
		min-height: 100%;
		margin-right: -210px;
	}
	
	.g-mn1 {
		float: right;
		width: calc(100% - 210px);
		height: 100%;
	}
	
	.g-mn1c {
		margin-left: 5px;
		width: 100%;
		height: 100%;
		/*padding-top: 10px;*/
	}
	
	.tentative-box {
		/*border: solid red 1px;*/
		margin-left: 210px;
	}
	
	#nav {
		.f-fl {
			img {
				display: inline-block;
				vertical-align: middle;
			}
			span {
				padding: 0 10px;
				height: 100%;
				font-size: 16px;
				font-weight: 600;
				display: inline-block;
			}
			p {
				text-align: left;
				font-size: 16px;
				font-weight: 500;
			}
		}
		.f-fr {
			width: 40%;
			text-align: right;
			.use-box {
				span {
					font-size: 14px;
				}
				a {
					color: white;
					font-size: 14px;
				}
			}
			.control-box {
				padding-top: 15px;
				text-align: right;
			}
		}
	}
	
	.columntrait {
		span {
			color: #2b80bc;
			font-size: 14px;
			font-weight: 600;
		}
		img {
			margin-right: 5px;
		}
		i {
			font-size: 14px;
			font-weight: 600;
		}
	}
	
	.el-menu-vertical-demo {}
	
	.el-submenu__title {
		background-color: #f9f9f9;
	}
	
	.j-describe {
		/*border: solid red 1px;*/
		padding: 20px 0;
		font-size: 15px;
		/*margin-top: -30px;*/
		/*position: absolute;*/
		/*top: 0;*/
		width: 100%;
		background-color: #f9f9f9;
		text-align: center;
		.con {
			display: inline-block;
			vertical-align: middle;
			margin-right: 10px;
			color: #2263b6;
		}
	}
			.top-nav-tit {
			display: inline-block;
			text-align: left;
			/*padding: 10px;*/
			padding: 12px 0 8px 10px;
			text-align: left;
			/*padding-left: 100px;*/
			/*width: 80%;*/
			width: 90%;
			font-size: 18px;
			font-weight: 500;
			/*color: #2263b7;*/
			/*background-color: #ecf8ff;*/
			/*padding-left: 200px;*/
			margin-top: -10px;
			border-bottom: solid #2b80bc 2px;
			margin-bottom: 40px;
		}
</style>